import SandboxUploadComponent from 'components/utility/sandbox_upload/component'
import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { transformAttachmentsForSandboxUploader } from '../utils'
import {
  removeRespondingFile,
} from 'components/QuestionnaireRequestAutomated/processor/slices/globalSlice'

export default function AutoQuestionnaireAttachments({ initialAttachments }) {
  const dispatch = useDispatch()
  const attachmentsMap = useSelector((state) => state.global.attachmentsMap)
  const hashedId = useSelector((state) => state.global.hashedId)
  const existingFiles = useMemo(
    () => transformAttachmentsForSandboxUploader(initialAttachments || {}),
    [initialAttachments]
  )

  const onRemovePdfFile = useCallback(
    (sandboxFile) => {
      const attachmentId = attachmentsMap[sandboxFile.fileUUID]
      if (attachmentId) {
        dispatch(
          removeRespondingFile({
            questionnaireRequestId: hashedId,
            attachmentId,
            fileSandboxId: sandboxFile.fileUUID,
          })
        )
      }
    },
    [attachmentsMap, hashedId]
  )

  return (
    <div>
      <SandboxUploadComponent
        uploaderUUID={hashedId}
        multiple={true}
        label="choose file(s)"
        existingFiles={existingFiles}
        onFileRemoved={onRemovePdfFile}
      />
    </div>
  )
}
